<template>
    <main class="flex items-center">
        <div>
            <tooltip :content="tooltip" position="bottom">
                <button
                    class="w-32 h-32 flex items-center justify-center cursor-pointer text-primary hover:text-secondary disabled:cursor-default disabled:text-primary-40"
                    @click="showTasks"
                >
                    <svg-icon :type="icon" :size="iconSize"></svg-icon>
                </button>
            </tooltip>
        </div>
        <popout
            :show="show"
            title=""
            @close="closeTasks"
        >
            <div class="w-480">
                <tasks-detail
                    :key="'tasks_' + _uid"
                    @navigation="closeTasks"
                    filterable
                ></tasks-detail>
            </div>
        </popout>
    </main>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
import Tooltip from '../navigation/Tooltip.vue';
import Popout from './Popout.vue';
import TasksDetail from './TasksDetail.vue';
import EventBus from '../../../shared/eventbus';

export default {
    components: {
        'svg-icon': SvgIcon,
        'tooltip': Tooltip,
        'popout': Popout,
        'tasks-detail': TasksDetail,
    },
    props: {
        icon: String,
        iconSize: {type: String, default: '16'},
        tooltip: String,
    },
    data: function () {
        return {
            show: false,
        }
    },
    methods: {
        showTasks () {
            this.show = true;
        },
        closeTasks () {
            this.show = false;
        },
    },
    mounted() {
        EventBus.addEventListener('open-tasks-popout', () => {
            this.show = true;
        })
    }
}
</script>
